const React = require('react');
const { StyleSheetManager } = require('styled-components');

const isPropValidModule = require('@emotion/is-prop-valid');
const isPropValid = isPropValidModule.default || isPropValidModule;

// styled-components v6 no longer auto-filters non-standard props from native
// DOM elements (v5 did this automatically). Without filtering, styled-system
// props (bg, mt, gridColumn, ...) and custom props (noFooter, dark, ...) leak
// onto DOM nodes and flood the console with React "unknown prop" warnings.
//
// Restore the v5 behavior: only forward valid HTML attributes to native
// elements (target is a tag string); always forward to React components.
const shouldForwardProp = (propName, target) => {
  if (typeof target === 'string') {
    return isPropValid(propName);
  }
  return true;
};

exports.wrapRootElement = ({ element }) =>
  React.createElement(StyleSheetManager, { shouldForwardProp }, element);
